<template>
    <div class="content" v-show="isContractAuth">
        <div class="content-info">
            <div class="info-top">
                <div class="Dprog">3D方案</div>
                <div class="number">{{new_code}}</div>
            </div>
            <div class="title">{{new_address_area}}</div>
            <div class="plan_lable">
                <p>{{ objAccount.new_area ? objAccount.new_area + ' m²' : '' }}</p>
                <p>
                    {{ objAccount.new_roomnumber ? objAccount.new_roomnumber + '室' : '' }}{{
                        objAccount.new_hall ? objAccount.new_hall + '厅' : ''
                    }}{{ objAccount.new_toilet ? objAccount.new_toilet + '卫' : '' }}{{
                        objAccount.new_kitchen ? objAccount.new_kitchen + '厨' : ''
                    }}
                </p>
                <p>{{ objAccount.new_housetype_name ? objAccount.new_housetype_name : '' }}</p>
            </div>
            <!-- <div class="lable">
                <div class="square">{{ objAccount.new_area ? objAccount.new_area + ' m²' : '不详' }}</div>
                <div class="room">
                    {{objAccount.new_roomnumber ? objAccount.new_roomnumber + "室" : ""}}{{objAccount.new_hall ? objAccount.new_hall + "厅" : ""}}{{objAccount.new_toilet ? objAccount.new_toilet + "卫" : ""}}
                </div>
                <div class="type">{{ objAccount.new_housetype_name ? objAccount.new_housetype_name : "不详" }}</div>
            </div> -->
        </div>
        <div class="threeBox">
            <div class="title">3D设计方案</div>
            <iframe width="100%" height="100%" :src="url"></iframe>
        </div>
        <div class="home_icon" @click="getHome"  :style="{bottom: showInfo? '108px':'88px'}">
            <img  src="@/assets/images/member/v2/plan/home_icon.png"/>
        </div>
        <share :isFixed="true" v-if="showInfo" track-action="share_wind_design"></share>
    </div>
</template>

<script>
    import share from '../components/share.vue'
    import {getReportShare} from "@/js/member/mynews/index.js";
    export default {
        components: {
            share
        },
        data() {
            return {
                isContractAuth:false,
                objAccount: [],
                url: '',
                new_code: '',
                showInfo:false,
                shareTimeLog:null,
                new_address_area:'',
                Object:{}
            }
        },
        created() {
            this.$store.commit("loadSkeleton", {bool: true}); // 页面loading开启
            this.Object = this.$route.query;
            if (this.Object.sampleroom == 2 || this.Object.sampleroom == 3) {
                this.showInfo = true;
            }
            $init(()=>{
                if(this.$route.query.projectmgnid){
                    this.$storage.setStorage('project_uuid',this.$route.query.projectmgnid)
                }
                if(this.$route.query.form=='wxwork'){
                    this.$storage.setStorage('share_source', 'wxwork') //通知过来的
                }
                this.$oInitData.memberInfo({
                    h5_user_id: this.$storage.getStorage("user_id"),
                }).then((res) => {
                    this.isContractAuth=true
                    Promise.all([
                        this.$userHouse.dispatch("getHouser",this.Object)
                    ]).then((res) => {
                        this.$store.commit("loadSkeleton", {bool: false}); // 页面loading开启
                        this.objAccount = this.$userHouse.state.usreHouserList.account; // 用户信息
                        this.new_code = this.$userHouse.state.usreHouserList.contract.new_code
                        this.new_address_area = this.$userHouse.state.usreHouserList.contract.new_address || ''
                        if (this.$route.query.url) {
                            this.url = this.$route.query.url
                            console.log(this.url, '2')
                        } else {
                            let btn = this.$userHouse.state.usreHouserList.btn;
                            btn.forEach((item) => {
                                if (item.type_key == 'third_img') {
                                    this.url = item.type_id
                                    console.log(this.url, '1')
                                }
                            })
                        }
                    }).catch((error) => console.log(erro));
                }).finally(f=>{
                    if (this.$route.query.shareId>0) {
                        let shareData = {
                            url:window.location.href,
                            project_uuid:this.$route.query.projectmgnid || this.$route.query.project_uuid,
                            id: this.$route.query.shareId,
                        }
                        getReportShare(shareData).then(res=>{
                            shareData.log_id=res.data.data.result.log_id
                            this.shareTimeLog= setInterval(()=>{
                                getReportShare(shareData)
                            },2000)
                        })
                    }
                })
            })

        },
        beforeDestroy() {
            clearInterval(this.shareTimeLog)
            this.shareTimeLog=null
        },
        mounted() {
            console.log(this.$route.query.url, 'url')
        },
        methods: {
            getHome(){
                let objSam =this.$route.query;
                this.$router.push(`/member/v2/index/index?sharePersonId=${objSam.sharePersonId || ''}&sampleroom=${objSam.sampleroom || ''}&accountid=${objSam.accountid || ''}&contractid=${objSam.contractid || ''}&systemuserid=${objSam.systemuserid || ''}`)
            }
        }
    }
</script>

<style scoped lang="scss">
    .content {
        width: 100%;
        height: 100vh;
        background: #7AA894;

        .content-info {
            padding: 64px 64px 48px 56px;

            .info-top {
                display: flex;
                justify-content: space-between;

                .Dprog {
                    width: 112px;
                    height: 40px;
                    background: #0D53FC;
                    border-radius: 21px;
                    text-align: center;
                    line-height: 42px;
                    font-size: 22px;
                    color: #FFFFFF;
                    font-weight: 400;
                }

                .number {
                    height: 40px;
                    font-size: 20px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 40px;
                }
            }

            .plan_lable {
                margin-top: 40px;

                p {
                    padding: 0 32px;
                    display: inline-block;
                    font-size: 24px;
                    color: $whiteText;
                    color: rgba(255, 255, 255, 0.8);
                }

                p:nth-child(1) {
                    padding-left: 0;
                }

                p:nth-child(2) {
                    border-left: 1px solid rgba(255, 255, 255, 0.7);
                    border-right: 1px solid rgba(255, 255, 255, 0.7);
                }
            }

            .title {
                margin: 58px 0 32px 0;
                font-size: 36px;
                color: #FFFFFF;
            }

            .lable {
                margin-top: 32px;
                /* padding: 12px 0 32px 0; */
                display: flex;

                .square {
                    font-size: 24px;
                    color: rgba(255, 255, 255, 0.7);
                    padding-right: 32px;
                    border-right: 2px solid rgba(255, 255, 255, 0.7);
                }

                .room {
                    padding: 0 32px;
                    font-size: 24px;
                    color: rgba(255, 255, 255, 0.7);
                    border-right: 2px solid rgba(255, 255, 255, 0.7);
                }

                .type {
                    padding: 0 32px;
                    font-size: 24px;
                    color: rgba(255, 255, 255, 0.7);
                }
            }
        }

        .threeBox {
            width: 100%;
            height: 78vh;
            background: #F9F9F9;
            border-radius: 24px 24px 0px 0px;

            .title {
                font-size: 32px;
                font-weight: 500;
                color: #333333;
                padding: 64px 64px 32px 64px;
            }
        }
        .home_icon{
            position: fixed;
            right: 4px;
            img{
                width: 112px;
                height: 112px;
            }
        }
    }
</style>
